import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { setFirstTimeFlags, unsetFirstTimeFlag } from './actions';
import { handleActions } from 'redux-actions';
const actionHandlers = handleActions({
    [setFirstTimeFlags.toString()]: (state, { payload: flags })=>_object_spread({}, state, flags),
    [unsetFirstTimeFlag.toString()]: (state, { payload: { flag } })=>_object_spread_props(_object_spread({}, state), {
            [flag]: false
        })
}, {});
export default {
    [reduxKey]: actionHandlers
};
